import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { ClickableItem, HealthPlan } from "../../../utils/api-objects/HealthPlan"
import { saveEvent } from "../../../utils/apis/user-service"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { HealthPlanDataBox, HealthPlanDataBoxWithCheckbox } from "./HealthPlanCard"

interface HealthPlanPreviewProps {
    healthPlan: HealthPlan,
}

const HealthPlanPreview = (props: HealthPlanPreviewProps) => {
    const { sendEvent } = useCreateEvent()
    const healthPlan = props.healthPlan
    const { userData } = useUserStore()
    const email = userData.email
    const navigate = useNavigate()
    const categories = [
        { title: "🥙  Alimenti consigliati", data: healthPlan.data.food_suggested ? healthPlan.data.food_suggested : [] },
        { title: "💊  Integratori consigliati", data: healthPlan.data.integrators_suggested ? healthPlan.data.integrators_suggested : [] },
        { title: "🩺  Check-up consigliati", data: healthPlan.data.check_ups_suggested ? healthPlan.data.check_ups_suggested : [] },
        { title: "📝  Commento", data: healthPlan.data.comment ?? [] } // Ensure it's always an array
    ]
        .filter(category => category.data.length > 0) // Keep only non-empty categories
        .slice(0, 2);

    const onOpenHealthPlanClick = async () => {
        navigate("/health-plan")
        if (!email) return
        saveEvent(
            email,
            "open_health_plan_button_clicked",
            (success) => console.log(success),
            (error) => console.log(error),
            "home_page"
        )
        await sendEvent({
            event: EventType.CLICK,
            sub_category: "open_health_plan",
        })
    }

    useEffect(() => {
        void sendEvent({
            event: EventType.WIDGET_VIEW,
            sub_category: "health_plan_widget",
        })
    }, [])
    return (
        <div className="bg-[#F5F5F5] rounded-xl pt-[15px] pb-[10px] px-[10px] space-y-sm max-w-[800px]">
            <div className="w-full flex items-center justify-between">
                <div className="font-bold text-[14px]">
                    In evidenza dal tuo Health Plan
                </div>
                <div
                    className="font-bold text-[12px] text-holifya-blue cursor-pointer"
                    onClick={onOpenHealthPlanClick}
                >
                    Apri
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px]">
                {categories.map((category, index) => (
                    category.title === "📝  Commento" ?
                        <HealthPlanDataBox key={index} title={category.title} data={category.data as string[]} source={"home_page"} /> :
                        <HealthPlanDataBoxWithCheckbox key={index} title={category.title} data={category.data as ClickableItem[]} fullData={healthPlan.data} planId={healthPlan.id} source="home_page" />
                ))}
            </div>
        </div>
    )
}

export default HealthPlanPreview
